import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ListDocTypesResponse} from '../models/responses';
import {DocType} from '../models/doc-type';
import {ApiService, API_DOC_TYPES} from './api.service';
@Injectable({
  providedIn: 'root'
})

export class DocTypeService {
  public selected: string;

  constructor(
    private apiService: ApiService
  ) {}

  public getDocTypes(): Observable<DocType[]> {
    return this.apiService.http.get<ListDocTypesResponse>(API_DOC_TYPES)
      .pipe(
        map((listSickNote: ListDocTypesResponse) => listSickNote.sick_notes_types),
        map((types) => {
          return types
            .sort((a, b) => a?.name?.localeCompare(b?.name, undefined, { numeric: true }))
            .map((docType) => ({
              id: String(docType.id),
              label: docType.name,
              description: docType.description,
            }));
      }));
  }
}
